import usePDPContext from './usePDPContext';
const DEFAULT_VALUE = {};
const usePDPOptions = () => {
  return usePDPContext()?.productOptions ?? DEFAULT_VALUE;
};
export default usePDPOptions;